import React, { useEffect, useState, useCallback } from 'react'
import './postproject.css'
import FilterSidebar from './postproj/FilterSidebar';
import ProjectCard from './postproj/ProjectCard';
import axios from 'axios';

const Find = () => {
const [data, setdata] = useState(null)

  const [Query, setQuery] = useState([""])

  const fetchData = useCallback(async () => {
    console.log("hi")
    try {
      console.log("hi");
      let obj = Query;
      const filteredObj = Object.keys(obj).reduce((acc, key) => {
        if (obj[key] !== null) {
          acc[key] = obj[key];
        }
        return acc;
      }, {});
      console.log(filteredObj)

      // Send a GET request with Axios
      await axios.get(`${process.env.REACT_APP_HOST1}/post/list`, {  params: filteredObj
        , headers: {
        "Content-Type": "application/json",
        "accessToken": localStorage.getItem("accessToken"),//bad practise
    }, })
        .then(response => {
          setdata(response.data);
        })
        .catch(error => {
          console.error('Error fetching data: ', error);
        });
    } catch (error) {
      console.error(error)
    }
  }, [Query]);

  useEffect(() => {
    fetchData();
  }, [fetchData])


  return (
    <>
    <div className="w-full px-[10%] min-h-[150dvh]">
    <div className="header">Discover Projects</div>
    {/* <div className="search-bar">
        <div className="search-container">
        <img src="search.png" alt="Search-icon" className="search-icon" />
        <input type="text" className="search" placeholder="Search" />
        </div>
    </div> */}
    <div className="grid-container">
        <FilterSidebar setQuery={setQuery} Query={Query} />
        <div className="project-list">
        {data && Object.keys(data).map((item,index) => (
            <div className="project-card" key={index}>
                <ProjectCard project={data[index]} />
            </div>
        ))}
        </div>
    </div>
    </div>

    </>
  )
}

export default Find
